import * as type from './types';

export function setSeletedAllTypes(data) {
    return {
        type: type.STORE_SELECTED_TYPES_ALL_REQUESTED,
        data: data,
    }
}